<template>
  <div class="service-container">
    <router-view id="change-view"></router-view>
  </div>
</template>

<script>
export default {
  name: "serviceMobile"
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.service-container {
  display: flex;
  flex-wrap: nowrap;
  padding: 140px 70px 60px 70px;
  @include betweenPhoneTable {
    flex-wrap: wrap;
    margin: 0px 15px;
    padding: 140px 15px;
  }
}
#change-view {
  margin: 0 auto;
  max-width: 656px;
  width: 100%;

  @include tablePro {
    // max-width: 656px;
  }
  @include phone {
    // width: 100%;
  }
}
</style>
